import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateMailTemplateRequest } from "../../hooks/useUpdateMailTemplateRequest";
import { useMailTemplateDetailRequest } from "../../hooks/useMailTemplateDetailRequest";
import { useDeleteMailTemplateRequest } from "../../hooks/useDeleteMailTemplateRequest";
import { MailTemplateForm } from "./MailTemplateForm";
import { type MailTemplateFormData } from "../../types/schemas";

export const MailTemplateEdit: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const templateId = parseInt(id as string);
  const { data } = useMailTemplateDetailRequest(templateId);
  const updateMailTemplate = useUpdateMailTemplateRequest(templateId);
  const deleteMailTemplate = useDeleteMailTemplateRequest();

  const handleSubmit = (data: MailTemplateFormData): void => {
    updateMailTemplate(data);
  };

  const handleDelete = (): void => {
    if (confirm("メールテンプレートを削除してもよろしいですか？")) {
      deleteMailTemplate([templateId]);
      navigate(`/emailManagement/mailTemplate/list`);
    }
  };

  if (!data) return null;

  return (
    <MailTemplateForm
      initialValues={data}
      onSubmit={handleSubmit}
      onDelete={handleDelete}
    />
  );
};
